// src/utils/loadDaumPostcode.js
let loaded = false;
export function loadDaumPostcode() {
  return new Promise((resolve, reject) => {
    if (loaded || window.daum?.Postcode) return resolve();
    const s = document.createElement("script");
    s.src = "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    s.onload = () => { loaded = true; resolve(); };
    s.onerror = reject;
    document.head.appendChild(s);
  });
}
